import React from 'react';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Segment, Header, Button /*, Image */} from 'semantic-ui-react';
import CompressedImage from '../elements/CompressedImage';

export default function ErrorComponent({ message }) {
  const { error } = useSelector((state) => state.async);
  const errorImage = [
    '/assets/images/error1_300.png',
    '/assets/images/error2_300.png',
    '/assets/images/notFound1_300.png',
  ];
  const notFoundImage = [
    '/assets/images/notFound1_300.png',
    '/assets/images/notFound2_300.png',
    '/assets/images/notFound3_300.png',
  ];

  let imageURL;
  const randomNumber = Math.floor(Math.random() * 3);
  // const
  if (
    message === "Sorry, I didn't find anything" ||
    error?.message === "Sorry, I didn't find anything"
  ) {
    imageURL = notFoundImage[randomNumber];
  } else {
    imageURL = errorImage[randomNumber];
  }

  console.log(error?.message);
  return (
    <Fragment>
      {' '}
      <Segment placeholder style={{ marginBottom: '0px!important' }}>
        <Header
          as={'h1'}
          textAlign='center'
          content={message || error?.message || 'Oh no, something went wrong!'}
        />

        <CompressedImage
          webp={true}
          jxr={true}
          jpf={true}
          src={imageURL}
          width='151'
          height='300'
          style={{
            height: 'auto',
            width: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />

        <h3 style={{ textAlign: 'center' }}>
          But don't worry, you can go search the library while I figure it out!
        </h3>
        <Button
          as={Link}
          to='/lib'
          primary
          style={{ marginTop: 0 }}
          content='Search the Library'
        />
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </Segment>
    </Fragment>
  );
}
